import { VehicleInformationType } from '@thesavingsgroup/enums/VehicleInformationType';
import { UserVehicleInformationDto } from '@thesavingsgroup/user-vehicle-information/UserVehicleInformationDto';
import get from 'lodash/get';

export const getVehicleInformationByType = (
  information: UserVehicleInformationDto[] | null | undefined,
  type: VehicleInformationType,
): UserVehicleInformationDto | undefined => {
  return information?.find((entry): boolean => get(entry, 'type') === type);
};
